var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2134 25.6518C23.7365 26.1738 24.5835 26.1733 25.106 25.6508C25.6289 25.1279 25.6289 24.2801 25.106 23.7572L19.06 17.7112C18.4742 17.1254 17.5245 17.1254 16.9387 17.7112L10.8927 23.7572C10.3698 24.2801 10.3698 25.1279 10.8927 25.6508C11.4152 26.1733 12.2622 26.1738 12.7852 25.6518L17.9993 20.4491L23.2134 25.6518Z",
    fill: "#7C7C7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7852 11.4341C12.2622 10.9122 11.4152 10.9126 10.8927 11.4351C10.3698 11.958 10.3698 12.8058 10.8927 13.3287L16.9387 19.3748C17.5245 19.9605 18.4742 19.9605 19.06 19.3748L25.106 13.3287C25.6289 12.8058 25.6289 11.958 25.106 11.4351C24.5835 10.9126 23.7365 10.9122 23.2134 11.4341L17.9993 16.6369L12.7852 11.4341Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBig);
export default __webpack_public_path__ + "static/media/closeBig.18b28128f00d0be457c95670ba02bcd0.svg";
export { ForwardRef as ReactComponent };